import { render } from "./GraphWidgetLayout.vue?vue&type=template&id=52923735"
import script from "./GraphWidgetLayout.vue?vue&type=script&lang=js"
export * from "./GraphWidgetLayout.vue?vue&type=script&lang=js"

import "./GraphWidgetLayout.vue?vue&type=style&index=0&id=52923735&lang=scss"
script.render = render

export default script